import { FifoLogger } from 'fifo-logger';

import { appendAcuteToxicity } from './appendAcuteToxicity.js';
import { appendLongTermToxicity } from './appendLongTermToxicity.js';
import { appendMiscellaneous } from './appendMiscellaneous.js';
import { appendReactivityAndInstability } from './appendReactivityAndInstability.js';
import { appendVolumeAndFlammability } from './appendVolumeAndFlammability.js';
import { filterReagents } from './normalize/filterReagents.js';
import { prepareReagents } from './normalize/prepareReagents.js';

export async function calculateSafety(originalReagents, options = {}) {
  options = {
    logger: new FifoLogger({ level: 'info' }),
    ...options,
  };
  const reagents = await prepareReagents(originalReagents, options);

  const filteredReagents = filterReagents(reagents, options);

  const report = { scores: {} };
  appendAcuteToxicity(filteredReagents, report, options);
  appendReactivityAndInstability(filteredReagents, report, options);
  appendVolumeAndFlammability(filteredReagents, report, options);
  appendLongTermToxicity(filteredReagents, report, options);
  appendMiscellaneous(filteredReagents, report, options);

  report.errors = options.logger.getLogs({ level: 'error' });
  report.finalScore =
    Object.values(report.scores).reduce((sum, score) => sum + score, 0) +
    report.miscellaneous.reduce((sum, misc) => sum + misc.score, 0);

  const hasRed =
    report.redAcuteToxicity.length > 0 ||
    report.redReactivityAndInstabilities.length > 0;
  if (report.finalScore <= 12 && !hasRed) {
    report.class = 1;
  } else if (report.finalScore > 18) {
    report.class = 3;
  } else {
    report.class = 2;
  }
  return { reagents, filteredReagents, report };
}
